import React from "react"
import Prompt from "shared/components/Prompt/index"

const NotificationFixedVoice = () => {
  return (
    <Prompt iconName="Info" hiddenButtons>
      Atendimento: Ativação/Portabilidade: voznanuvem@algar.com.br / Problemas
      técnicos e Demais solicitações: 0800 940 2999 - WhatsApp: (34) 99889-2822
    </Prompt>
  )
}
export default NotificationFixedVoice



// WEBPACK FOOTER //
// ./src/components/Masthead/components/NotificationFixedVoice.js